<div class="container">
  <div class="main-container main-container-menu">
    <div class="main-container--row justify-center">
      @for (ima of newJsonStructure; track ima; let index = $index) {
        <div class="desktop-container image-container menu-content main-container--column main-col-12 main-col-lg-12 main-col-md-12 main-col-sm-12 main-col-xs-12 justify-space-between">
          <div class="slider">
            <div class="slider-item lazy-img-slot">
              <picture>
                <source type="image/webp" [attr.data-srcset]="ima.secondName">
                <source type="image/png" [attr.data-srcset]="ima.name">
                <img [attr.data-src]="ima.secondName" [alt]="ima.alt" id="menu-{{index}}" loading="lazy" decoding="async"/>
              </picture>
            </div>
          </div>
        </div>
      }
      @if (hiddenMobileMenu) {
        @for (ima of newJsonStructure; track ima; let index = $index) {
          <div class="mobile-container image-container menu-content main-container--column main-col-12 main-col-lg-12 main-col-md-12 main-col-sm-12 main-col-xs-12 justify-space-between">
            <div class="slider">
              <div class="slider-item lazy-img-slot">
                <picture>
                  <source type="image/webp" [attr.data-srcset]="ima.secondName">
                  <source type="image/png" [attr.data-srcset]="ima.name">
                  <img [attr.data-src]="ima.secondName" [alt]="ima.alt" id="menu-mobile-{{index}}" loading="lazy" decoding="async"/>
                </picture>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
